export const ROUTES = {
  HOMEPAGE_ROUTE: '/',

  // Auth
  LOGIN_ROUTE: '/ingresar',
  PROFILE_ROUTE: '/perfil',
  REGISTER_ROUTE: '/registrarse',
  VALIDATE_EMAIL_ROUTE: '/validar-email',
  FORGOT_PASSWORD_ROUTE: '/olvide-contraseña',
  RESET_PASSWORD_ROUTE: '/recuperar-contraseña',

  // User type registration
  SELECT_ROLE_ROUTE: '/seleccionar-rol',
  MINER_REGISTRATION_ROUTE: '/registro/productor',
  PADRON_DE_MINAS_REGISTRATION_ROUTE: '/registro/padron-de-minas',
  NON_MINER_REGISTRATION_ROUTE: '/registro/no-productor',

  // User establecimientos
  USUARIO_ESTABLECIMIENTOS_ROUTE: '/usuario/establecimientos',
  USUARIO_ESTABLECIMIENTOS_DETAILS_ROUTE: '/usuario/establecimientos/:id',
  USUARIO_ESTABLECIMIENTOS_NUEVO_ROUTE: '/usuario/establecimientos/nuevo',
  USUARIO_BUQUES_DETAILS_ROUTE: '/usuario/buques/:id',

  // User cateos
  USUARIO_CATEOS_ROUTE: '/usuario/cateos',
  USUARIO_CATEOS_DETAILS_ROUTE: '/usuario/cateos/:id',

  // Guias de emision
  GUIA_EMISION_ROUTE: '/guias/emision',
  USUARIO_GUIAS_EMITIDAS_ROUTE: '/usuario/guias-emitidas',
  USUARIO_GUIAS_EMITIDAS_DETAILS_ROUTE: '/usuario/guias-emitidas/:id',
  PUBLIC_GUIAS_DOWNLOAD_ROUTE: '/public/guias/:uuid',

  // Resumenes
  USUARIO_RESUMEN_ROUTE: '/usuario/resumen',

  // Modules
  USUARIO_MODULOS_ROUTE: '/usuario/modulos',
  USUARIO_MODULOS_NUEVO_ROUTE: '/usuario/modulos/nuevo',

  // --------------------
  // Admins
  // --------------------

  // No Productores
  ADMIN_NO_PRODUCTORES_ROUTE: '/administracion/no-productores',
  ADMIN_NO_PRODUCTORES_ALTA_ROUTE: '/administracion/no-productores/alta',
  ADMIN_NO_PRODUCTORES_DETAILS_ROUTE: '/administracion/no-productores/:id',

  // Productores Mineros
  ADMIN_PRODUCTORES_ROUTE: '/administracion/productores',
  ADMIN_PRODUCTORES_ALTA_ROUTE: '/administracion/productores/alta',
  ADMIN_PRODUCTORES_DETAILS_ROUTE: '/administracion/productores/:id',

  // Padrones de Mineras
  ADMIN_PADRONES_DE_MINAS_ROUTE: '/administracion/padrones-de-minas',
  ADMIN_PADRONES_DE_MINAS_ALTA_ROUTE: '/administracion/padrones-de-minas/alta',
  ADMIN_PADRONES_DE_MINAS_DETAILS_ROUTE: '/administracion/padrones-de-minas/:id',

  // Establecimientos Mineros
  ADMIN_ESTABLECIMIENTOS_MINEROS_ROUTE: '/administracion/establecimientos-mineros',
  ADMIN_ESTABLECIMIENTOS_MINEROS_ALTA_ROUTE: '/administracion/establecimientos-mineros/alta',
  ADMIN_ESTABLECIMIENTOS_MINEROS_EDIT_ROUTE: '/administracion/establecimientos-mineros/:id/editar',
  ADMIN_ESTABLECIMIENTOS_MINEROS_DETAILS_ROUTE: '/administracion/establecimientos-mineros/:id',

  // Concesiones Mineras
  ADMIN_CONCESIONES_MINERAS_ALTA_ROUTE: '/administracion/concesiones-mineras/alta',
  ADMIN_CONCESIONES_MINERAS_EDIT_ROUTE: '/administracion/concesiones-mineras/:id/editar',

  // Establecimientos No Mineros
  ADMIN_ESTABLECIMIENTOS_NO_MINEROS_ALTA_ROUTE: '/administracion/establecimientos-no-mineros/alta',
  ADMIN_ESTABLECIMIENTOS_NO_MINEROS_DETAILS_ROUTE:
    '/administracion/establecimientos-no-mineros/:id',

  // Cateos
  ADMIN_CATEOS_ROUTE: '/administracion/cateos',
  ADMIN_CATEOS_ALTA_ROUTE: '/administracion/cateos/alta',
  ADMIN_CATEOS_DETAILS_ROUTE: '/administracion/cateos/:id',

  // Buques
  ADMIN_BUQUES_ROUTE: '/administracion/buques',
  ADMIN_BUQUES_ALTA_ROUTE: '/administracion/buques/alta',
  ADMIN_BUQUES_DETAILS_ROUTE: '/administracion/buques/:id',

  // Guías
  ADMIN_GUIAS_ROUTE: '/administracion/guias',
  ADMIN_GUIAS_DETAILS_ROUTE: '/administracion/guias/:id',

  // Comprobantes
  ADMIN_COMPROBANTES_ROUTE: '/administracion/comprobantes'
};
